import React from 'react'

const NavContent = ({ content, active = '', id, }) => (
    <div className={`tab-pane fade ${active}`}
        id={ id }
        role="tabpanel"
        aria-labelledby={`${id}-tab`}    
    >
        { content }
    </div>
)

export default  NavContent


// WEBPACK FOOTER //
// ./src/components/utilities/NavContent.js